module.exports = __webpack_public_path__ + "img/ring_r_s_null_1.8a66b040.png";